import React from 'react';
import { usePopper } from 'react-popper';
import Icon from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as InfoErrorCircleOutlineSvg } from '@/images/icons/info-error-circle-outline.svg';
import styles from './meetingroomuntiltip.module.scss';
import { getIn18Text } from 'api';
const InfoErrorCircleOutlineIcon = props => React.createElement(Icon, Object.assign({ component: InfoErrorCircleOutlineSvg }, props));
const MeetingRoomUntilTip = ({ onOk, untilDateTime: untilDateTimeFunc, getReferenceElement, onReselectMeetingRoom, onReselectDateTime, type, offset, getBoundaryElment, }) => {
    const untilDateTime = typeof untilDateTimeFunc === 'function' ? untilDateTimeFunc() : untilDateTimeFunc;
    const [referenceElement, setReferenceElement] = React.useState(null);
    const [popperElement, setPopperElement] = React.useState(null);
    const { styles: poperStyles, attributes } = usePopper(referenceElement, popperElement, {
        placement: 'bottom-start',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: offset || [-12, 5],
                },
            },
            {
                name: 'preventOverflow',
                options: {
                    boundary: getBoundaryElment ? getBoundaryElment() : undefined,
                },
            },
        ],
    });
    React.useEffect(() => {
        if (type) {
            setReferenceElement(getReferenceElement());
        }
    }, [type]);
    if (!type) {
        return null;
    }
    return (React.createElement("div", Object.assign({ ref: setPopperElement, style: Object.assign({ zIndex: 1 }, poperStyles.popper), className: styles.poper }, attributes.popper),
        React.createElement(InfoErrorCircleOutlineIcon, { style: { fontSize: 16, marginRight: 8 } }),
        type === 'until_error' && (React.createElement(React.Fragment, null,
            React.createElement("span", null, getIn18Text('HUIYISHIZHIZHI')),
            React.createElement("span", null, untilDateTime === null || untilDateTime === void 0 ? void 0 : untilDateTime.format(getIn18Text('NIANYUERI'))),
            React.createElement("a", { className: styles.opBtn, onClick: e => {
                    e.preventDefault();
                    onOk && onOk(untilDateTime);
                } }, getIn18Text('YIJIANDIAOZHENG')))),
        type === 'cur_room_invalid' && (React.createElement(React.Fragment, null,
            React.createElement("span", null, getIn18Text('DANGQIANRICHENGSHI')),
            React.createElement("a", { className: styles.opBtn, onClick: e => {
                    e.preventDefault();
                    onReselectMeetingRoom && onReselectMeetingRoom();
                } }, getIn18Text('ZHONGXINXUANZE')))),
        type === 'all_room_invalid' && (React.createElement(React.Fragment, null,
            React.createElement("span", null, getIn18Text('DANGQIANRICHENGXIA')),
            React.createElement("a", { className: styles.opBtn, onClick: e => {
                    e.preventDefault();
                    onReselectDateTime && onReselectDateTime();
                } }, getIn18Text('QUEDING'))))));
};
export default MeetingRoomUntilTip;
